const blazeOrange = '#ff6d01';
const claret = '#741b47';
const cornflowerBlue = '#6D9EEB';
const cucumber = '#6AA84F';
const gold = '#BF9000';
const guardsmanRed = '#CC0000';
const black = '#000';
const magenta = '#ff00ff';
const green = '#00FF00';
const darkred = '#5b0f00';

const firstCategory = {
  color: blazeOrange,
  category: [
    'Handyman',
    'Services',
    'Crafts',
    'Tools',
    // 'Legumes(beans, lents...etc.)',
    // 'Mushrooms',
    // 'Fruit syrups and lemonade',
  ],
};

const secondCategory = {
  color: claret,
  category: [
    'Friuts and vegetables',
    'Pickles, jams, marmelades',
    'Ready meals',
    'Sweets',
    'Bakery products and pastry',
    'Herbs',
    'Garden surpluses',
  ],
};

const thirdCategory = {
  color: cornflowerBlue,
  category: ['Cosmetics, beauty and health'],
};

const fourthCategory = {
  color: cucumber,
  category: ['Elecrtonics'],
};

const fifthCategory = {
  color: gold,
  category: [
    'Kitchen and accessories',
    'Cooking',
    'Bathroom and accessories',
    'Furniture',
    'Small furniture',
    'Matraces',
    'Decorations',
    'Home accessories',
    'Home textile',
    'Pictures and frames',
    'Mirrors',
    'Carpets and floorings',
    'Heaters',
    'Lights',
    'Ventilators',
    'Collecting, antique, arts',
  ],
};

const sixthCategory = {
  color: guardsmanRed,
  category: [
    'Garden furniture',
    'Garden',
    'Flowers',
    'Grilling',
    'Dools and accessories',
  ],
};

const seventhCategory = {
  color: black,
  category: ['Clothes', 'Shoes', 'Bags and luggages'],
};

const eightCategory = {
  color: black,
  category: [
    'Childerns accessories',
    'Childrens furniture',
    'Childrens clothes',
    'Childrens shoes',
    'Toy',
    'Books and textbooks',
    'Video games, films, CDs',
    'Music and musical instruments',
  ],
};

const ninthCategory = {
  color: magenta,
  category: ['Sport accessories', 'Sport clothes'],
};

const tenthCategory = {
  color: green,
  category: ['Cars', 'Motorbiking', 'Cykling'],
};
const eleventhCategory = { color: darkred, category: ['For pets', 'Others'] };

export const CategoryList = [
  firstCategory,
  secondCategory,
  thirdCategory,
  fourthCategory,
  fifthCategory,
  sixthCategory,
  seventhCategory,
  eightCategory,
  ninthCategory,
  tenthCategory,
  eleventhCategory,
];
